import { dispatch } from "@rematch/core";
import { practicesService } from "../services/feathers.service";

const ACTIVE_GENERATION_WINDOW_MS = 30 * 60 * 1000;

// Blocks starting a new playbook/activity generation while one is already
// actively running for the account. playbookGenerationStatus 0/1 means
// generation is in progress; 2 is complete and -1 is errored (both are not
// "in progress" and must not block). updatedAt is checked against a 30 min
// window so a job stuck by a lost message/crashed consumer doesn't
// permanently lock the account out of generating anything else.
export async function isBlockedByActiveGeneration({ accountId }) {
  const inProgress = await practicesService.find({
    query: {
      accountId,
      playbookGenerationStatus: { $in: [0, 1] },
      updatedAt: { $gte: new Date(Date.now() - ACTIVE_GENERATION_WINDOW_MS) },
      $limit: 1,
      $select: ["_id", "name", "createdBy"],
      $populate: [
        {
          path: "createdBy",
          select: "_id firstName lastName email",
        },
      ],
    },
  });

  if (inProgress && inProgress.length > 0) {
    const activePlaybook = inProgress[0];
    const creator = activePlaybook.createdBy;
    const userName = creator
      ? `${creator.firstName || ""} ${creator.lastName || ""}`.trim() || creator.email
      : "Another user";

    dispatch.app.setActiveGenerationBlockedProps({
      userName,
      playbookName: activePlaybook.name,
    });
    dispatch.app.setActiveGenerationBlockedModal(true);
    return true;
  }

  return false;
}
